import { render } from "./NewTipSplitModal.vue?vue&type=template&id=32da5b79"
import script from "./NewTipSplitModal.vue?vue&type=script&lang=js"
export * from "./NewTipSplitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__